import { DecisionContext, ProjectStatus } from "@/dbot/common/commonDomain";
import { makeAutoObservable } from "mobx";
import { DecisionType } from "@/common/decisions";
import { PreviousBusinessManager } from "@/dbot/changeOfBusinessManager/changeOfBusinessManagerDomain";

export type NoBusinessManager = {
  type: DecisionType.noBusinessManager;
  previousBusinessManager: PreviousBusinessManager;
};

export class NoBusinessManagerForm {
  readonly type = DecisionType.noBusinessManager;
  readonly context: DecisionContext<NoBusinessManager>;
  readonly data?: NoBusinessManager;

  constructor(context: DecisionContext<NoBusinessManager>, data?: NoBusinessManager) {
    makeAutoObservable(this, { type: false, data: false }, { autoBind: true });
    this.context = context;
    this.data = data;
  }

  get currentBusinessManager() {
    return this.context.contextData[this.context.orgNo]?.initialState?.currentBusinessManager;
  }

  get hasBusinessManager(): boolean {
    return (
      this.context.projectStatus !== ProjectStatus.DRAFT ||
      this.currentBusinessManager !== undefined
    );
  }

  get previousBusinessManager(): PreviousBusinessManager | undefined {
    const current = this.currentBusinessManager;
    if (!current) return undefined;
    return {
      name: current.name,
      organisationNumber: current.organisationNumber,
      businessAddress1: current.businessAddress1,
      businessAddress2: current.businessAddress2,
      businessZip: current.businessZip,
      businessCity: current.businessCity,
      businessCountry: current.businessCountry,
    };
  }

  get isProjectLocked(): boolean {
    return this.context.isLocked;
  }
}
